var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nuxt-link',{directives:[{name:"track-click",rawName:"v-track-click"}],attrs:{"id":_vm.id,"to":_vm.landingPageUrl}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }